import React from 'react'
import { useLogout } from '../../application/hooks/useLogout'
import { useSelfSelectFlow } from '../../application/hooks/useSelfSelectFlow'
import { useRouter } from '../../application/router/useRouter'
import { PayloadUnwrapper } from '../../components/Error/PayloadUnwrapper'
import { SelfSelectLayout, UnsupportedFund } from '../../components/SelfSelect'

const UnsupportedFundPage: React.FC = () => {
  const { logout } = useLogout()
  const { back } = useRouter()
  const flow = useSelfSelectFlow()

  return (
    <PayloadUnwrapper item={flow}>
      {(flow) => (
        <SelfSelectLayout>
          <UnsupportedFund
            logOut={logout}
            goBack={back}
            titleText={flow.unsupportedFundTitleText}
            unsupportedFundText={flow.unsupportedFundText}
          />
        </SelfSelectLayout>
      )}
    </PayloadUnwrapper>
  )
}

export default UnsupportedFundPage
